<template>
    <div class="d-flex vh-100 align-items-center justify-content-center">
        <div class="card shadow p-4" style="width: 350px;">
            <div class="card-body">
                <h3 class="text-center mb-3">Login</h3>

                <form @submit.prevent="login">
                    <div class="mb-3">
                        <bs5-base-label for="email">Email address</bs5-base-label>
                        <bs5-base-input type="email" v-model="model.login" id="email" placeholder="Enter your email"
                            required />
                    </div>

                    <div class="mb-3">
                        <bs5-base-label for="password">Password</bs5-base-label>
                        <bs5-base-input type="password" v-model="model.password" id="password"
                            placeholder="Enter your password" required />
                    </div>
                    <bs5-base-button variant="primary" type="submit" class="w-100">Sign in</bs5-base-button>
                </form>

                <div class="text-center mt-3">
                    <a href="#" class="text-decoration-none">Don't have an account? Sign up</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useAuthStore } from "@/stores/auth.store";

export default defineComponent({
    data() {
        return {
            model: {
                login: '',
                password: ''
            },
            authStore: useAuthStore(), // Inicjalizacja store'a w Options API
        };
    },
    methods: {
        async login() {
            try{
                await this.authStore.login(this.model.login, this.model.password);
                console.log("Login successful", this.authStore.user);
            }
            catch(er){
                console.log(er);
            }
            finally{
                console.log("koniec");
            }
        }
    }
});
</script>